import { default as moment } from './moment';

export const getDate = date => {
	if (!date) {
		return '-';
	}

	return moment(date).format('DD-MM-YYYY');
};
